import React, { useEffect, useState } from "react";
import "./HandPrint.css";
import { useHistory } from "../../app-services/lib/router-compat";
// Pages
import { useParams } from "react-router-dom";
import PreventUnload from "./PreventUnload";
import ModalPopup from "./PopupModal/Index";

import BookManage from "./BookManage";
import mixins from "../../app-services/mixins";

const defaultdedication = `<p>Believe in yourself</p> <p>and dare to dream!</p> <p>You are always loved.</p>`;

const CustomCharacterBook = (props) => {
  const history = useHistory();
  const customCharacter = props.store?.customCharacter || [];
  const { id, customBookId } = useParams();
  const worldbookPreInfo = props.store?.book?.customCharacter;
  const answer = worldbookPreInfo?.answer;
  const [pages, setPages] = useState([]);
  const [currentopenpage, setCurrentopenpage] = useState(0);
  const [showModal, setShowModal] = useState(true);
  const [gettingBook, setGettingBook] = useState(true);

  const handleClick = (componentname) => {
    setShowModal(componentname);
  };

  const handlecomponent = () => {
    if (customCharacter?.length > 2) {
      handleClick("book");
    } else {
      handleClick("info");
    }
  }
  useEffect(() => {
    if (!customBookId) {
      handlecomponent('info')
    }
  }, []);
  const getProductDetails = () => { };

  const getLatestBook = (customBookId) => {
    setGettingBook(true);
    getLatestBookCall(customBookId).then((responce) => {
      setTimeout(() => {
        setGettingBook(false);
        handleClick("book");
      }, 100);
    });
  };
  const getLatestBookCall = (id) => {
    return new Promise((resolve, reject) => {
      api
        .getSelfPublish(id)
        .then((response) => {
          if (response && response.data) {
            let responcedata = response.data;
            let attributes = JSON.parse(responcedata?.attributes || "{}");
            let arrayData = Array.isArray(attributes)
              ? attributes
              : Object.values(attributes);
            let payload = Object.deepClone(arrayData);
            mixins.setStore("customCharacter", payload, props);

            setTimeout(() => {
              resolve(responcedata);
            }, 0);
          } else {
            resolve(savedBook);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  useEffect(() => {
    if (customBookId) {
      getLatestBook(customBookId);
    }
    if (id) {
      getProductDetails();
    }
  }, [customBookId]);

  const toPreviewfunc = () => {
    setShowModal("book");
  };

  const handleclose = () => {
    if (customCharacter?.length > 2) {
      setShowModal("book");
    } else {
      let subCat = localStorage.subCategory;
      history.push(`/custom-books/product-list/${subCat}`);
    }
  };

  return (
    <PreventUnload>
      <div className="worldbook new-custom-character pb-4">
        {customBookId ? (
          <>
            {gettingBook ? (
              <>
                <div
                  style={{
                    minHeight: "60vh",
                  }}
                ></div>
              </>
            ) : (
              <>
                {showModal == "book" ? (
                  <BookManage setShowModal={setShowModal} defaultdedication={defaultdedication} />
                ) : (
                  <ModalPopup
                    show={showModal}
                    handleclosemodal={handleclose}
                    proceedsave={toPreviewfunc}
                    customCharacter={customCharacter}
                    defaultdedication={defaultdedication}
                  />
                )}
              </>
            )}
          </>
        ) : (
          <>
            {showModal == "book" ? (
              <BookManage setShowModal={setShowModal}  defaultdedication={defaultdedication} />
            ) : (
              <ModalPopup
                show={showModal}
                handleclosemodal={handleclose}
                proceedsave={toPreviewfunc}
                customCharacter={customCharacter}
                 defaultdedication={defaultdedication}
              />
            )}
          </>
        )}
      </div>
    </PreventUnload>
  );
};

export default connect(CustomCharacterBook);
